import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import moment from 'moment-timezone'

const BatchCard = ({ value, batch, title, type = 'course' }) => {
    // //console.log(batch)

    const BatchStyle = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "31%",
        maxWidth: "31%",
        minHeight: "130px",
        background: "#e6e6ff",
        borderRadius: "15px",
        boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.20)",
        transition: "all 0.3s",
        translate: `${value}px`,
        padding: "10px",
        // translate: `20px`
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return moment.tz(dateString, "UTC")
            .tz("Asia/Kolkata")
            .format("MMM DD, YYYY"); // e.g., "Jan 15, 2024"
    };

    const getExpiryStatus = (expiryDate) => {
        if (!expiryDate) return 'N/A';
        const now = moment();
        const expiry = moment.tz(expiryDate, "UTC").tz("Asia/Kolkata");
        const daysLeft = expiry.diff(now, 'days');
        if (daysLeft < 0) {
            return "Expired";
        } else if (daysLeft <= 7) {
            return `Expiring in ${daysLeft} days`;
        } else {
            return "Active";
        }
    };

    const renderSubscriptionContent = () => (
        <>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                Purchased: {formatDate(batch?.purchased_at)}
            </Typography>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                Expiry: {formatDate(batch?.expiry_date)}
            </Typography>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                Status: {getExpiryStatus(batch?.expiry_date)}
            </Typography>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500' }}>
                Results: {batch?.result_count || 0}
            </Typography>
        </>
    );

    const renderCourseContent = () => (
        <>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                Start Date: {formatDate(batch?.starting_date)}
            </Typography>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                Registration End: {formatDate(batch?.registration_end_date)}
            </Typography>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                Status: {getExpiryStatus(batch?.registration_end_date)}
            </Typography>
            {batch?.validity && (
                <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                    Validity: {batch?.validity} days
                </Typography>
            )}
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500' }}>
                Results: {batch?.result_count || 0}
            </Typography>
        </>
    );

    const renderTestSeriesContent = () => (
        <>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                Start Date: {formatDate(batch?.starting_date)}
            </Typography>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                End Date: {formatDate(batch?.ending_date)}
            </Typography>
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                Status: {getExpiryStatus(batch?.ending_date)}
            </Typography>
            {batch?.Validity && (
                <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500', marginBottom: '4px' }}>
                    Validity: {batch?.Validity} days
                </Typography>
            )}
            <Typography color="black" fontSize="small" sx={{ textAlign: 'center', fontWeight: '500' }}>
                Results: {batch?.result_count || 0}
            </Typography>
        </>
    );

    return (
        <Box sx={{ ...BatchStyle }}>
            <Typography color="black" fontSize="medium" sx={{ textAlign: 'center', fontWeight: '700', marginBottom: '8px' }}>
                {batch?.name ? batch?.name : title}
            </Typography>
            {type === 'subscription' ? renderSubscriptionContent() :
             type === 'testseries' ? renderTestSeriesContent() :
             renderCourseContent()
            }
        </Box>
    )
}

export default BatchCard